import React from 'react';
import { FaTimes } from '../../../components/icons'; 
import colors from '../../../utils/colors'; 

interface FilterChipProps {
  label: string;
  onClear: () => void;
  className?: string; 
}

const FilterChip: React.FC<FilterChipProps> = ({ label, onClear, className }) => {
  return (
    <div 
      className={`flex items-center text-sm font-semibold px-3 py-1.5 rounded-full h-[40px] ${className || ''}`}
      style={{ backgroundColor: colors.lightGreen, color: colors.dark }} 
    >
      <span>{label}</span>
      <button
        onClick={onClear}
        className="ml-2 p-1 rounded-full hover:bg-black hover:bg-opacity-10 focus:outline-none" 
        aria-label={`Clear filter for ${label}`}
      >
        <FaTimes size={14} /> 
      </button>
    </div>
  );
};

export default FilterChip;